module.exports = __webpack_public_path__ + "img/ic_profile_wizard_resume.a3f2268b.svg";